type RollbackNotificationChannel = (notificationReceiver: () => void) => void;
export abstract class TransactionalIndexedDBWriter {
  private petitionReceiver: (() => void) | null = null;
  abstract getStores(): readonly string[];
  abstract writeToIdb(tx: IDBTransaction, rollbackNotificationChannel: RollbackNotificationChannel): void;
  public setWritePetitionReceiver(petitionReceiver: () => void): void {
    this.petitionReceiver = petitionReceiver;
  }
  protected petitionForWrite(): void {
    this.petitionReceiver?.();
  }
}